export const it_purpose = {
    purpose_title:'Vota o proponi la tua idea per migliorare Real Estate Pro. La più votata sarà realizzata prima delle altre.',
    purpose_alert:'Ooops! Puoi votare massimo 3 volte',
    purpose_sub:'PROPONI LA TUA IDEA',
    purpose_desc:'Scrivi qui sotto la tua idea',
    purpose_invia:'Invia',
   purpose_voti:'Voti',
   purpose_real:'Realizzata!',
   purpose_vota:'VOTA',


};